import api from "./api";

export async function fetchRapidFireBatchList(params = {}) {
  const response = await api.get("/rapidfire/batch-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchRapidFireLeaderboard(params = {}) {
  const response = await api.get("/rapidfire/get-rapidfire-leaderboard-data", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function createRapidFireBatch(data = {}) {
  const response = await api.post("/rapidfire/batch-create", data);
  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchRapidFireQuestions(params = {}) {
  const response = await api.get("/rapidfire/questions-details", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchRapidFireAnswerSheet(params = {}) {
  const response = await api.get("/rapidfire/answer-sheet", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
